import { render, staticRenderFns } from "./LimitedTimeAwardDeatailPopup.vue?vue&type=template&id=81b7b194&scoped=true&"
import script from "./LimitedTimeAwardDeatailPopup.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeAwardDeatailPopup.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeAwardDeatailPopup.vue?vue&type=style&index=0&id=81b7b194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b7b194",
  null
  
)

export default component.exports